var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-dot",class:{'color-dot--selected': _vm.selected},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"color-dot__core",style:({'background-color': _vm.color})})])
}
var staticRenderFns = []

export { render, staticRenderFns }